import "./Hom.scss";

import React, { FC, useEffect, useState } from "react";
import { observer } from "mobx-react";
import useWindowSize from 'react-use/lib/useWindowSize'
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { ThirdwebSDK } from "@thirdweb-dev/sdk/solana";
import Confetti from 'react-confetti'


export type Props = {};

const Home: FC<Props> = (props: Props) => {
  const [isWhitelisted, setIsWhitelisted] = useState<boolean>(true)
  const { publicKey } = useWallet();
  const [overlayText, setOverlayText] = useState("Connect your wallet with your 51Whitelist token to make sure you are on the official 51 Draco Whitelist")
  const [overlayTextColor, setOverlayTextColor] = useState("#d7c8c8")
  const [isExploding, setIsExploding] = useState(false);
  const { width, height } = useWindowSize()



  const getBalance = async (pk: string) => {
    console.log(String(process.env.REACT_APP_ENV))
    const sdk = String(process.env.REACT_APP_ENV)==="development"? ThirdwebSDK.fromNetwork("devnet"): ThirdwebSDK.fromNetwork("mainnet-beta");
    // Get the interface for your token program
    try {
      console.log(String(process.env.REACT_APP_WHITELIST_TOKEN_ADDRESS))
      const program = await sdk.getProgram(String(process.env.REACT_APP_WHITELIST_TOKEN_ADDRESS), "token"); //token address
      // @ts-ignore
      const balance = await program.balanceOf(pk);
      console.log("balance ", balance)
      if (Number(balance.displayValue) > 0){
        setIsWhitelisted(true)
        setOverlayText("Congratulations! You have X 51 Draco Whitelist spots!")
        setOverlayTextColor("#d7c8c8")
        setIsExploding(true)
      }
    }catch (e){
      console.log(e)
      setIsWhitelisted(false)
      setOverlayText("I'm sorry, you are not currently on the 51 Draco Whitelist")
      setIsExploding(false)
      setOverlayTextColor("#ff6868")
    }

  }

  useEffect(()=>{
    if (publicKey){
      getBalance(publicKey.toString())
    }else {
      setIsWhitelisted(false)
      setOverlayText("Connect your wallet with your 51Whitelist token to make sure you are on the official 51 Draco Whitelist")
      setIsExploding(false)
      setOverlayTextColor("#d7c8c8")
    }
  }, [publicKey]);

  // @ts-ignore
  return (
    <div className="App">
      <section className="content flex justify-center pt-10" style={{background: "black"}}>
        <div className="flex justify-center mx-1 py-5 w-full" style={{background: "black"}}>
          <div className="night">
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
            <div className="shooting_star"></div>
          </div>
          <img
              className="flex mx-auto relative w-full h-60 sm:w-72 sm:h-72 bg-home-cover"
              src={require("./assets/images/wl_bottom_pge.png")}
          />
          <div className="absolute text-3xl w-1/2 text-center" style={{color: `${overlayTextColor}`, fontFamily: 'Draco2'}}>
            {overlayText}
          </div>
          {isExploding && <Confetti
              width={width}
              height={height}
          />}
        </div>
      </section>
    </div>
  );
};

export default observer(Home);
